import { useAppStore } from '../stores/useAppStore';
import Page from '../components/Page';
import CardSpeaker from '../components/CardSpeaker';
import { CAROUSEL_TYPES } from '../constants/carouselTypes';
import { motion } from 'motion/react';

const MotionCardSpeaker = motion.create(CardSpeaker);

function PageCiscoSpeakingSessions() {
  const { content: { speaking_sessions: content }, setCardTouchPos } = useAppStore();
  const { openCarousel } = useAppStore((state) => state.carousel);

  const speakers = content.items || [];

  const handleCardClick = (event, index) => {
      let x, y;
  
      if (event.touches) {
        // Evento táctil
        x = event.touches[0].clientX;
        y = event.touches[0].clientY;
      } else {
        // Evento de ratón
        x = event.clientX;
        y = event.clientY;
      }
      setCardTouchPos({x, y});
      
      openCarousel(index, CAROUSEL_TYPES.SPEAKERS);
    };

  return (
    <Page className="pr-220u pt-600u pb-469u relative">
      <div className='absolute top-285u left-1/2 text-100u font-extralight -translate-x-1/2 z-30'>{content.title}</div>
      <div className="flex flex-row h-full gap-53u">
        {speakers.map((speaker, index) => (
          <MotionCardSpeaker
            key={speaker.id}
            initial={{ opacity: 0, y: 20, filter: "blur(3px)" }}
            animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            transition={{
              duration: 0.6,
              ease: "easeOut",
              delay: index * 0.5
            }}
            item={speaker}
            isOpen={false}
            onClick={(event) => handleCardClick(event, index)} />
          
        ))}
      </div>
    </Page>
  );
}

export default PageCiscoSpeakingSessions;